import { DataMap } from '@grapecity/wijmo.grid'

import { ListItem } from '../utility'
import { BaseEnumEx } from './base-enum-ex'

export enum EquipmentReportType {
    Daily,
    Issue,
    Fuel,
    Grease,
    Mechanic,
    Tire,
}

export class EquipmentReportTypeEx extends BaseEnumEx {
    public static toDisplay(item: EquipmentReportType) {
        switch (item) {
            case EquipmentReportType.Daily:
                return 'Daily Report'
            case EquipmentReportType.Issue:
                return 'Report an Issue'
            case EquipmentReportType.Fuel:
                return 'Fuel Needed'
            case EquipmentReportType.Grease:
                return 'Grease or Fluid Needed'
            case EquipmentReportType.Mechanic:
                return 'Mechanic Inspection'
            case EquipmentReportType.Tire:
                return 'Tire Issue'
        }
        return 'Unknown'
    }

    public static toDataMap(): DataMap {
        return new DataMap(EquipmentReportTypeEx.toListItems(), 'value', 'display')
    }

    public static toListItems(): ListItem<number>[] {
        return [
            new ListItem(EquipmentReportType.Daily, EquipmentReportTypeEx.toDisplay(EquipmentReportType.Daily)),
            new ListItem(EquipmentReportType.Issue, EquipmentReportTypeEx.toDisplay(EquipmentReportType.Issue)),
            new ListItem(EquipmentReportType.Fuel, EquipmentReportTypeEx.toDisplay(EquipmentReportType.Fuel)),
            new ListItem(EquipmentReportType.Grease, EquipmentReportTypeEx.toDisplay(EquipmentReportType.Grease)),
            new ListItem(EquipmentReportType.Mechanic, EquipmentReportTypeEx.toDisplay(EquipmentReportType.Mechanic)),
            new ListItem(EquipmentReportType.Tire, EquipmentReportTypeEx.toDisplay(EquipmentReportType.Tire)),
        ]
    }
}
